<template>
  <div class="header">
    <Header></Header>
      <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <img width="300px" src="../../assets/picture/occupation/banner2.png">
        </div>
        <img class="fr mt30" width="300px" src="../../assets/picture/occupation/t11.png">
      </div>
    </div>
    <!-- section1 -->
    <div class="section1">
      <div class="container">
        <div class="crumbs">
          <span><img src="../../assets/picture/occupation/more.png"></span>
          <span @click="goHome">返回首页</span>
        </div>
        <div class="detailBox">
          <div class="title">
          {{detail.title}}
          </div>
          <p class="dec" v-html="detail.content"></p>
          <!-- <div v-for="(item,index) in detail.list" :key="index">
            <div class="subTitle">
              <i></i>
              <span>{{item.title}}</span>
            </div>
            <p v-for="(sub,num) in item.sub" :key="num">{{num+1}}.{{sub.name}}</p>
          </div> -->
         <!--  <p>请投递简历至邮箱：careers@jqinvestments.com</p>
          <p>标题格式：姓名-投递职位-工作年限。注意投递职位为“资深量化策略研究员”。</p> -->
        </div>      
      </div>
    </div>
    <!-- section2 -->
    <!-- <Code></Code> -->
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
// import Code from '../common/code';
export default {
  data() {
    return {
      liIndex:-1,
      id:'',
      isShowSearch:false,
      detail:[],
      part:[
        {
          id:0,
          title:'量化策略研究员',
          dec:'作为量化策略研究员，你将会是佳期的灵魂所在。你的工作除了对各类数据进行深入探索和研究，量化建模、我们还需要你与现有团队精诚合作，共同以严谨审慎的态度，不断地创造、审视、改进策略模型，持续创新引领行业进步。我们希望你有硬核的理工科背景、良好的数理基础、对量化的热爱、澎湃的好奇心和创造力、强烈的自我驱动力和学习能力，并享受团队协作的研究氛围。',
          list:[
          {
            title:'岗位职责',
            sub:[
              {
                name:'对金融领域的市场数据、基本面数据、另类数据进行深入探索与研究 ',
              },
              {
                name:'基于统计学、经济学、机器学习等方法，对投资逻辑进行模型化 ',
              },
              {
                name:'参与量化交易策略的研发、构建、测试、优化以及风险管理',
              },
              {
                name:'对量化投资策略的表现进行跟踪、分析和评估',
              }
            ]
          },
          {
            title:'技能要求',
            sub:[
              {
                name:'毕业于国内外知名高校的相关专业，如数学、统计学、物理学、计算机科学、金融 工程等',
              },
              {
                name:'具备深入并丰富的数据处理、统计建模、机器学习等方面的知识储备',
              },
              {
                name:'具熟练使用 Python/R 语言进行数据分析；熟悉机器学习常用工具（如 TensorFlow、 PyTorch 等）',
              },
              {
                name:'有 Kaggle 等数据挖掘、数学建模、机器学习类竞赛经验更佳',
              },
              {
                name:'具备科学化思维方式、具有强烈的求知欲和自我学习能力'
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:1,
          title:'量化交易员',
          dec:'作为量化交易员，你将负责监督公司自动化策略的运作，确保交易的正常进行。交易员的岗位职责包括：1）在交易中发现异常情况或出现交易差错、电脑系统故障和其他影响交易正常进行的问题时，及时向主管反馈；2）准确地执行投资交易指令，按时完成交易任务，汇总交易情况，并向上级报告；3）负责查验交易计划、对交易计划中的资金和风险进行核查；4）负责交易数据的整理、收集与汇总工作。',
          list:[
          {
            title:'岗位职责',
            sub:[
              {
                name:'本科及以上学历，金融、经济等相关专业优先，2年左右的工作经验或有相关实习经验的应届毕业生；',
              },
              {
                name:'对证券/期货交易感兴趣，具有证券/期货交易工作经验更佳；',
              },
              {
                name:'能够持之以恒的坚持抗压能力强，愿意做夜班；',
              },
              {
                name:'具备较强的学习能力及执行能力，有良好的团队意识；',
              },
              {
                name:'性格稳重严谨、风险意识较强，工作仔细认真、品行端正。',
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:2,
          title:'核心系统工程师',
          dec:'作为核心系统工程师，你将与我们的Geek团队一起，设计、搭建和维护公司的高性能的交易系统，在佳期这个技术与投研并重的团队里，你也将是团队的中坚力量。我们希望你熟练掌握C++、Linux系统、可以持续探索核心系统性能瓶颈、突破技术难点、实现改进方案；也需要你享受编程、享受创造、享受合作，与交易员和策略研究员深度合作，完成技术的全面推动。',
          list:[
          {
            title:'技能要求',
            sub:[
              {
                name:'毕业于国内外知名高校的计算机科学、电子工程等相关专业',
              },
              {
                name:'有丰富的C/C++开发经验，具备扎实的编程能力',
              },
              {
                name:'有ACM/ICPC或其他编程类竞赛经验更佳',
              },
              {
                name:'对新科技充满热情、对编程精益求精、有良好的沟通能力',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:3,
          title:'算法开发工程师',
          dec:'作为算法开发工程师，你将与业界顶尖的策略研究员及核心开发人员紧密合作，在日常工作中负责策略框架的设计、交易策略程序的编写、维护、调试和优化。算法开发工程师不仅仅立足当下，更面向未来。在佳期，你还将研究并实现新颖的模型计算方法，以提高策略的交易效率。',
          list:[
          {
            title:'技能要求',
            sub:[
              {
                name:'毕业于国内外知名高校的计算机科学相关专业',
              },
              {
                name:'有C/C++开发工作经验并熟练使用Python语言，具备扎实的编程能力和算法知识',
              },
              {
                name:'有策略研究、策略实现工作经验更佳',
              },
              {
                name:'有出色的分析能力、认真严谨、追求极致',
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:4,
          title:'技术项目经理',
          dec:'作为技术项目经理，你需要对公司每个技术项目的进度都了如指掌，统筹项目发展，确保项目的每个节点都可以准时高质完成。对于项目中可能出现的问题，你需要运用自己优秀的沟通与技术理解能力同项目成员进行专业的探讨，寻找最优的工作流程和解决方法。除此之外，你还是项目团队成员间的润滑剂和粘合剂，需要充分了解各位成员的工作方式与思路，运用出色的协调能力打造高效的项目团队。',
          list:[
          {
            title:'任职要求',
            sub:[
              {
                name:'毕业于国内外知名高校的理工科专业；',
              },
              {
                name:'三年以上技术项目管理经验，熟悉项目生命周期管理，具有PMP等项目管理证书更佳；',
              },
              {
                name:'熟悉C++、Python等编程语言更佳；',
              },
              {
                name:'极强的协调能力与良好的英文沟通能力、出色的项目文档管理能力；',
              },
              {
                name:'具备良好的自我驱动能力，适应快节奏工作环境，能妥善平衡资源和优先级。',
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:5,
          title:'机器学习研究员',
          dec:'作为AI研究员，你将会做一系列AI前瞻领域的预研和实验，充分利用强大的计算资源对海量的金融数据进行挖掘，在特征提取、价格预测、组合优化、算法实现等不同的量化场景实践和应用你的AI算法。你可以不用了解金融市场，我们将会为你打造独特的研究框架让你可以快速上手并专注于机器学习算法的应用，希望你葆有科学家的心态和研究方式，和我们的精英团队一起，在金融市场中迎接新的挑战，紧跟领域前沿，推动基础研究，让AI的应用在量化里熠熠生辉。如果你是应届生，且对于AI领域有着强烈的兴趣和丰富的实践经验，我们会是你最佳的学习环境和实践空间。你在团队中的职责会随着你研究能力的提升，而同步迅速增长。在公司成熟的研究体系指导下，你会很快成长为AI能手。',
          list:[
          {
            title:'应聘要求',
            sub:[
              {
                name:'毕业于国内外知名高校的相关专业，如计算机科学、统计、物理等',
              },
              {
                name:'熟练Python，以及PyTorch或TensorFlow',
              },
              {
                name:'拥有深度学习学术研究或实习实践经验优先',
              },
              {
                name:'具备科学化思维方式、具有强烈的求知欲和自学能力',
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:6,
          title:'资深机器学习研究员',
          dec:'佳期投资最核心的驱动力是对数据分析领域的持续钻研与探索。我们坚信技术积累、进化与创新是公司成长和投资回报最核心的来源。迄今为止，佳期团队已经在机器学习领域有了多年的积累与实践。如果你已有AI行业的职业经验，我们将给你提供最佳的用武之地。我们将在你已有的知识基础上建立更加深入和前沿的理论和实践知识。你将探索如何将传统AI领域的前沿方法论应用在量化金融行业，从中得到大量的学习机会和职业回报！',
          list:[
          {
            title:'应聘要求',
            sub:[
              {
                name:'来自领先AI团队的核心成员',
              },
              {
                name:'拥有大量的研究和实践经验',
              },
              {
                name:'掌握AI领域前沿的学术与应用知识',
              }
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:7,
          title:'机器学习专家',
          dec:'如果你已是AI学术研究或应用领域的专家，我们诚恳邀请你加入我们团队。研究能力是我们的核心竞争力。针对顶尖的研究团队和前沿的研究课题，我们不惜付出、不吝长期的时间和金钱投入，积极搭建需要的团队和研究环境。我们相信，加入我们会给你的科研工作与事业发展带来质的飞跃！',
          list:[
          {
            title:'应聘要求',
            sub:[
              {
                name:'某AI领域领先专家，拥有突破性的创新',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:8,
          title:'招聘/HR专员',
          dec:'作为招聘/HR专员，你将是佳期所有未来员工的第一印象传递者，对外代表我们整个团队的价值观、文化和使命。你需要用心关注每一位候选人的面试体验，并了解他们对自己生活的梦想和期待。你需要有同理心，能够理解接受一份新的工作对任何一位候选人都是一次重要的抉择，而每位新同事的加入对于我们团队也绝非小事。  对内而言，你是公司员工可信赖的知心人和啦啦队，也是公司价值观和愉快高效工作环境的护卫者。你需要全面了解我们的业务，并通过公司文化建设和培训课程等方面，助力内部各团队有效地学习和工作。',
          list:[
          {
            title:'任职要求',
            sub:[
              {
                name:'985/211高校本科及以上学历，外国语言文学、汉语言文学、人力资源、经济学或相关专业；',
              },
              {
                name:'1-2年招聘或猎头工作经历，熟悉人力资源管理专业知识，熟知招聘工作流程；',
              },
              {
                name:'具备一定的金融专业知识更佳；',
              },
              {
                name:'具有高度责任感和工作热情，良好的主动沟通意识及学历能力、细心踏实。',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:9,
          title:'产品运营专员',
          dec:'作为产品运营专员，你将会接触到私募基金产品运作的全流程，是公司产品的大管家。从要素确认、到合同拟定，从协议审核、到开户备案，一系列流程都需要你全盘掌握、细心谨慎且高效地执行。任何新业务的拓展、政策与规定的变化都会给你的工作带来新的挑战，你需要运用专业知识与经验，以严谨的态度积极应对变化、拥抱成长。你还需要保持与外部合作方的充分交流，无论是托管外包还是经纪服务商，都需要你代表公司、用专业的态度与标准积极沟通落实每一步的大小细节。',
          list:[
          {
            title:'任职要求',
            sub:[
              {
                name:'985/211高校本科及以上学历，金融、经济等相关专业优先；',
              },
              {
                name:'1-2年工作经验，具有私募基金运营管理的经验更佳；',
              },
              {
                name:'具备较强的学习能力及沟通能力，有良好的团队意识；',
              },
              {
                name:'性格稳重严谨、工作细致认真、品行端正。',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:10,
          title:'投后管理专员',
          dec:'作为投后管理专员，投资者适当性审核标准是你应坚守的原则，客户服务意识是你日常工作贯穿始终的第一要义。作为公司与投资者之间沟通的桥梁，你将是投资者在佳期的“代言人”。你会从专业角度出发，帮助客户了解适合他们的基金产品、完成产品申赎手续，解决客户的日常需求。此外，向监管机构和投资者做好信息披露，也是工作重要的组成部分。你需要善于与人沟通交流、具有严谨且踏实的工作态度，帮助公司给所有投资人带来良好的投资体验。',
          list:[
          {
            title:'任职要求',
            sub:[
              {
                name:'985/211高校本科及以上学历，金融、经济等相关专业优先；',
              },
              {
                name:'1-2年工作经验，有对接金融客户的经历，具有二级市场投后管理的经验更佳；',
              },
              {
                name:'具备较强的学习能力及沟通能力，有良好的团队意识；',
              },
              {
                name:'开朗，擅长与人打交道，有同理心，工作细致认真、品行端正。',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },
        {
          id:11,
          title:'基金销售专员',
          dec:'作为基金销售专员，你将是佳期对外的一张名片，负责公司私募基金产品的募集与推广。你需要具备一定的私募基金基础知识、熟悉金融市场以及量化产品，协同销售总监对接外部合作伙伴，进行机构和渠道客户的开拓与维护。与投资者沟通时，要做到专业、耐心、细致且高效；协助产品运营事宜时，需要将所有流程了然于心；设计合作方案和产品结构时，需要有一定的探索创新能力，以实现双赢。',
          list:[
          {
            title:'任职要求',
            sub:[
              {
                name:'985/211高校本科及以上学历，金融、经济等相关专业优先；',
              },
              {
                name:'一年以上银行、券商、期货、基金、基金行政服务机构等行业经验；',
              },
              {
                name:'熟悉私募基金管理运作模式及产品设计，熟悉基金行业的法律法规和相关政策；',
              },
              {
                name:'具有较强的客户沟通及人际交往能力，性格外向开朗、工作仔细认真、品行端正。',
              },
            ]
          },
          {
            title:'工作地点',
            sub:[
              {
                name:'上海',
              },
              ]
            }
          ]
        },       
      ],
    };
  },
  components: { Header,Footer,},
  mounted(){
    this.id = this.$route.query.id;
    this.getArticleById();
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    //根据ID获取文章
     async getArticleById() {
         const { data: res } = await this.$http.get("/article/getArticleById.do?id="+this.id);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
       this.detail = res.data;
    },
    goHome(){
      this.$router.push({  
            path: '/',       
        })
    }
  }
};
</script>

<style lang="less" scoped>
.header{
  .bannerBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
       img{
        margin-top: 170px;
       }
    }
  }
  /*********************************************/
  .section1{
    padding-bottom: 193px;
    .crumbs{
      padding:40px 0 14px 0;
      border-bottom: 1px solid #D5D5D5;
      display: block;
      span{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
        line-height: 28px;
        letter-spacing: 1px;
        margin-right: 23px;
        cursor: pointer;
        img{
          width: 14px;
          height: 14px;
        }
      }
    }
    .detailBox{
      padding-top: 80px;
      .title{
        text-align: center;
        font-size: 35px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #353535;
        line-height: 49px;
        letter-spacing: 2px;
        margin-bottom: 52px;
      }
      .dec{
        margin-bottom: 30px;
      }
      .subTitle{
        margin-bottom: 18px;
        position: relative;
        i{
          display: inline-block;
          width: 4px;
          height: 22px;
          background: #900211;
          position: absolute;
          top: 4px;
        }
        span{
          margin-left: 10px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #900211;
          line-height: 28px;
          letter-spacing: 1px;
        }
      }
      p{        
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #353535;
        line-height: 32px;
        letter-spacing: 0.88px;
      }
      p:last-of-type{
        margin-bottom: 40px;
      }
    }
  }
}
</style>
